export const SwitchCasesList = ({ fill = "white" }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.2 0H0V5.2H5.2V0ZM3.9 3.9H1.3V1.3H3.9V3.9ZM5.2 6.5H0V11.7H5.2V6.5ZM3.9 10.4H1.3V7.8H3.9V10.4ZM14.3 19.5H19.5V14.3H14.3V19.5ZM15.6 15.6H18.2V18.2H15.6V15.6ZM14.3 26H19.5V20.8H14.3V26ZM15.6 22.1H18.2V24.7H15.6V22.1ZM20.8 19.5H26V14.3H20.8V19.5ZM22.1 15.6H24.7V18.2H22.1V15.6ZM20.8 26H26V20.8H20.8V26ZM22.1 22.1H24.7V24.7H22.1V22.1ZM8.9102 16.4403L11.9691 19.5L8.9102 22.5597L7.99032 21.6406L9.49416 20.1367C5.08456 19.9937 3.9 16.2843 3.9 14.3L5.2 14.2979C5.2013 14.4794 5.2845 18.6423 9.46296 18.8321L7.99032 17.3594L8.9102 16.4403ZM20.9898 9.5576L17.9309 6.49818L20.9898 3.4385L21.9094 4.3576L20.4058 5.86144C24.8154 6.00418 26 9.71386 26 11.6982L24.7 11.7C24.6987 11.5185 24.6158 7.35566 20.437 7.16586L21.9097 8.6385L20.9898 9.5576ZM15.6 1.3H6.5V0H15.6V1.3ZM15.6 5.2H6.5V3.9H15.6V5.2ZM15.6 3.25H6.5V1.95H15.6V3.25ZM15.6 7.8H6.5V6.5H15.6V7.8ZM15.6 11.7H6.5V10.4H15.6V11.7ZM15.6 9.75H6.5V8.45H15.6V9.75Z"
        fill={fill}
      />
    </svg>
  );
};
